const { initAlerts, initConfirmDelete } = require("./Utils");
import * as jq from "jquery"
jq(function () {
    initAlerts();
    initConfirmDelete();
    $('.multiselect').select2();
    $('.selectpicker').selectpicker();
});